export default Object.freeze({
  CompanyId: 'companyId',
  EnvironmentId: 'environmentId',
  ProcessInstanceId: 'processInstanceId',
  ActionInstanceId: 'actionInstanceId',
  InstanceIterationResultId: 'instanceIterationResultId',
  InstanceIterationResultNewStatus: 'instanceIterationResultNewStatus',
  IterationActionInstanceId: 'iterationActionInstanceId',
  IterationActionInstanceNewStatus: 'iterationActionInstanceNewStatus',
  OperationUserId: 'operationUserId',
  MessageType: 'messageType',
});
